import { render, staticRenderFns } from "./BookCreate.vue?vue&type=template&id=3d9c7f16"
import script from "./BookCreate.vue?vue&type=script&lang=js"
export * from "./BookCreate.vue?vue&type=script&lang=js"
import style0 from "./BookCreate.vue?vue&type=style&index=0&id=3d9c7f16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports